/* eslint-disable */
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.pluginCrossLine = void 0;
var defaultOptions = {
    lineColor: '#F66',
    lineWidth: 1,
    lineDashpattern: [],
    syncGroup: true,
    snap: true,
    yScales: ['y'],
    transformValue: undefined
};
// drawTracePoints() {
//   const { chart } = this;
//   for (let chartIndex = 0; chartIndex < chart.data.datasets.length; chartIndex++) {
//     const dataset = chart.data.datasets[chartIndex];
//     const meta = chart.getDatasetMeta(chartIndex);
//
//     const yScale = chart.scales[meta.yAxisID];
//
//     if (meta.hidden || !dataset.interpolate) {
//       continue;
//     }
//
//     chart.ctx.beginPath();
//     chart.ctx.arc(chart.crossLine.x, yScale.getPixelForValue(dataset.interpolatedValue), 3, 0, 2 * Math.PI, false);
//     chart.ctx.fillStyle = 'white';
//     chart.ctx.lineWidth = 2;
//     chart.ctx.strokeStyle = dataset.borderColor;
//     chart.ctx.fill();
//     chart.ctx.stroke();
//   }
// }
//
// interpolateValues() {
//   const { chart } = this;
//   for (let chartIndex = 0; chartIndex < chart.data.datasets.length; chartIndex++) {
//     const dataset = chart.data.datasets[chartIndex];
//
//     const meta = chart.getDatasetMeta(chartIndex);
//
//     const xScale = chart.scales[meta.xAxisID];
//     const xValue = xScale.getValueForPixel(chart.crossLine.x);
//
//     if (meta.hidden || !dataset.interpolate) {
//       continue;
//     }
//
//     const { data } = dataset;
//     const index = data.findIndex((o) => o.x >= xValue);
//     const prev = data[index - 1];
//     const next = data[index];
//
//     if (chart.data.datasets[chartIndex].steppedLine && prev) {
//       dataset.interpolatedValue = prev.y;
//     } else if (prev && next) {
//       const slope = (next.y - prev.y) / (next.x - prev.x);
//       dataset.interpolatedValue = prev.y + (xValue - prev.x) * slope;
//     } else {
//       dataset.interpolatedValue = NaN;
//     }
//     console.log(dataset.interpolatedValue);
//   }
// }
// Helpers:
function getOptions(chart) {
    var _a;
    // @ts-ignore // use ignore because plugin have not chartjs default setting
    return __assign(__assign({}, defaultOptions), (((_a = chart.config.options.plugins) === null || _a === void 0 ? void 0 : _a.crossLine) || {}));
}
// Plugin Body
exports.pluginCrossLine = {
    id: 'crossLine',
    start: function (chart) {
        chart.crossLine = {
            xPixel: null,
            suppressTooltip: false
        };
    },
    afterEvent: function (chart, args) {
        // exit if replay
        // if (args.replay) {
        //   return;
        // }
        var event = args.event;
        var type = event.type;
        var options = getOptions(chart);
        var xScale = chart.scales.x;
        var yScale = chart.scales.y;
        // exit if useless event type
        if (type !== 'mouseout' && type !== 'mousemove') {
            return;
        }
        // exit if default scales wasn't declared
        if (!xScale || !yScale) {
            return;
        }
        // set by default
        var suppressTooltip = event.emulated || false; // TODO: FIX HARDCODE
        var xPixel = event.x;
        // @ts-ignore
        // Get active points
        var active = chart._active;
        // if snap enabled
        // Define if tooltip will be suppressed
        // And define x pixels for emulated and original event by active point
        if (options.snap) {
            if (active.length && event.x !== null) {
                xPixel = active[0].element.x;
                if (event.emulated && Math.abs(event.x - xPixel) > 0.0001) {
                    suppressTooltip = true;
                    xPixel = event.x;
                }
            }
            else {
                if (event.emulated) {
                    suppressTooltip = true;
                }
                if (!args.inChartArea) {
                    xPixel = null;
                }
            }
        }
        // hide if mouse out from scale area
        if (xPixel !== null) {
            if (xPixel < xScale.getPixelForValue(xScale.min) || xPixel > xScale.getPixelForValue(xScale.max)) {
                xPixel = null;
            }
        }
        // Redraw if dependencies changed:
        if (chart.crossLine.xPixel !== xPixel) {
            args.changed = true;
            chart.crossLine.xPixel = xPixel;
        }
        if (chart.crossLine.suppressTooltip !== suppressTooltip) {
            args.changed = true;
            chart.crossLine.suppressTooltip = suppressTooltip;
        }
        // exit if sync disabled
        if (!options.syncGroup) {
            return;
        }
        // exit if event wasn't triggered by self
        if (event.emulated) {
            return;
        }
        // exit if group wasn't provided
        if (!chart.group) {
            return;
        }
        var xValue = null;
        // Get value by type
        if (xPixel) {
            var value = xScale.getValueForPixel(xPixel);
            if (value !== undefined) {
                xValue = value;
            }
            else {
                xValue = null;
            }
        }
        // Create & trigger event for other charts in group
        chart.group.otherCharts.forEach(function (otherChart) {
            var transformValue = getOptions(otherChart).transformValue;
            var xScaleLocal = otherChart.scales.x;
            var yScaleLocal = otherChart.scales.y;
            // exit if default scales wasn't declared
            if (!xScaleLocal || !yScaleLocal) {
                return;
            }
            var context = { chart: otherChart, scale: xScaleLocal };
            var xValueLocal = transformValue ? transformValue(context, xValue) : xValue;
            var xPixelLocal = xValueLocal === null ? null : xScaleLocal.getPixelForValue(xValueLocal);
            var yPixelLocal = yScaleLocal.getPixelForValue(yScaleLocal.min);
            // exit if line position wasn't change (for null value by default)
            if (otherChart.crossLine.xPixel === xPixelLocal) {
                return;
            }
            var newEvent = {
                type: type,
                x: xPixelLocal,
                y: yPixelLocal,
                // @ts-ignore
                native: {
                    // ...event.native,
                    type: type
                },
                chart: otherChart,
                emulated: true
            };
            // @ts-ignore
            otherChart._eventHandler(newEvent);
        });
    },
    afterDraw: function (chart) {
        var ctx = chart.ctx;
        var options = getOptions(chart);
        var lineWidth = options.lineWidth, lineDashpattern = options.lineDashpattern, lineColor = options.lineColor, yScales = options.yScales;
        var xPixel = chart.crossLine.xPixel;
        if (xPixel === null) {
            return;
        }
        ctx.beginPath();
        ctx.setLineDash(lineDashpattern);
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = lineColor;
        yScales === null || yScales === void 0 ? void 0 : yScales.forEach(function (id, index) {
            var xScale = chart.scales.x;
            var yScale = chart.scales[id];
            // exit if scales wasn't declared
            if (!xScale || !yScale) {
                return;
            }
            if (index) {
                ctx.lineTo(xPixel, yScale.getPixelForValue(yScale.max));
            }
            else {
                ctx.moveTo(xPixel, yScale.getPixelForValue(yScale.max));
            }
            ctx.lineTo(xPixel, yScale.getPixelForValue(yScale.min));
        });
        ctx.stroke();
        ctx.setLineDash([]);
        // chart.crossLine.interpolateValues();
        // chart.crossLine.drawTracePoints();
    },
    beforeTooltipDraw: function (chart, _a) {
        var tooltip = _a.tooltip;
        if (chart.crossLine.suppressTooltip) {
            // if beforeTooltipDraw return false tooltip should skip drawing, but bugged
            // To bypass this use opacity to prevent drawing
            tooltip.opacity = 0;
        }
    }
};
